var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTiktok = function SvgIconTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "-2 -1 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.074 0c.33 2.838 1.914 4.53 4.668 4.71v3.192c-1.596.156-2.994-.366-4.62-1.35v5.97c0 7.585-8.268 9.955-11.592 4.519-2.136-3.499-.828-9.637 6.024-9.883v3.366a10 10 0 0 0-1.59.39c-1.524.516-2.388 1.482-2.148 3.187.462 3.264 6.45 4.23 5.952-2.149V.006h3.306z"
  })));
};
export default SvgIconTiktok;